<template>
  <div>
    <div class="error-text">
      <p class="">PROHIBIDO</p>
    </div>

    <div class="">
      <a href="/" class="">
        <span class="btn-text"
          > <i class="mdi mdi-arrow-left"></i> REGRESAR AL INICIO</span>
      </a>
    </div>
  </div>
</template>
<style>
.error-text {
  font-size: 80px;
}
.btn-text {
  font-size: 50px;
}

@media (min-width: 768px) {
  .error-text {
    font-size: 130px;
  }
}
</style>